import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMaxHeight,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 600px;
  height: 450px;
  z-index: 5;
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  position: relative;

  ${mediaMaxWidth.phone} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

export const TitleText = styled.div`
  ${mediaMaxWidth.phone} {
    width: calc(100vw - 80px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Tooltip = styled.div`
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    font-size: 0.85em;
    color: rgb(187, 187, 187);
    transition: all 0.1s ease-in-out 0s;
  }

  ${mediaMaxWidth.tablet} {
    display: none;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 10px;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;

  button {
    margin: 5px 10px;
  }
`;

export const Engagements = styled.div`
  flex: 1;
  margin-bottom: 20px;

  ${mediaMaxWidth.tablet} {
    flex: unset;
  }
`;

export const Placements = styled.div`
  flex: 1;
  margin-bottom: 20px;
  position: relative;

  ${mediaMaxWidth.tablet} {
    flex: unset;
  }
`;

export const MobileTitle = styled.div`
  margin: 10px 0 0 0;
  text-transform: capitalize;
  font-size: 0.875em;
  font-style: italic;

  ${mediaMinWidth.tablet} {
    display: none;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 10px;
  height: 340px;
  overflow: scroll;

  ${mediaMaxWidth.tablet} {
    flex-direction: column;
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 5px 0 5px;
  }
`;

export const ListItem = styled.div`
  height: 44.25px;
  align-items: center;
  font-size: 0.95em;
  display: flex;

  svg.fa-check {
    color: #27ae60;
  }

  svg.fa-trophy {
    color: #eda225;
  }
`;

export const ListItemText = styled.div`
  padding-left: 15px;
  width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 70px);
  }
`;

export const PlacementsPlaceholder = styled.div`
  width: 100%;
  background-color: #fff;
  position: absolute;
  left: 0;
  height: 100%;
  z-index: 1;
  top: 0;
  justify-content: center;
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.tablet} {
    height: 80px;
  }
`;

export const PlaceholderText = styled.div`
  font-size: 0.95em;
  text-align: center;
  padding: 10px 50px;
`;
